import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'error-banner',
  templateUrl: 'error-banner.component.html',
  styleUrls: ['error-banner.component.scss'],
})
export class ErrorBannerComponent {
}
